
export const common_10_words= [
  {
    id:1,
    vietnamese:"Tôi",
    english: "I",
  },
  {
    id:2,
    vietnamese:"Bạn",
    english: "You",
  },
  {
    id:3,
    vietnamese:"Muốn",
    english: "Want",
  },
  {
    id:4,
    vietnamese:"Mua",
    english: "Buy",
  },
  {
    id:5,
    vietnamese:"Đau",
    english: "Pain",
  },
  {
    id:6,
    vietnamese:"Cậu bé",
    english: "Boy",
  },
  {
    id:7,
    vietnamese:"Con gái",
    english: "Girl",
  },
  {
    id:8,
    vietnamese:"Trả tiền",
    english: "Pay",
  },
  {
    id:9,
    vietnamese:"Gì",
    english: "What",
  },
  {
    id:10,
    vietnamese:"Ở đâu",
    english: "Where",
  },

]

